import React, {useContext, useEffect} from 'react';
import AuthContext from '../../context/autenticacion/authContext';
import ProyectoContext from '../../context/proyectos/proyectoContext'

const Barra = () => {

    // extraer la info de autenticacion
    const authContext = useContext(AuthContext);
    const { usuario, usuarioAutenticado, cerrarSesion } = authContext;

    const proyectoContext = useContext(ProyectoContext);
    const { salida } = proyectoContext;

    useEffect(() => {
        usuarioAutenticado();
        // eslint-disable-next-line
    }, []);

    const cierre = () => {
        salida();
        cerrarSesion()
    }

    return (  
        <header className="app-header">
            {usuario ? <p className="nombre-usuario">Hola <samp>{usuario.nombre}</samp></p> : null}            
            <nav className="nav-principal">
                <button 
                    className="btn btn-blank cerrar-sesion"
                    onClick={cierre}
                >Cerrar Sesión</button>
            </nav>
        </header>
    );
}
 
export default Barra;